// Masa berlaku TAUTAN dokumen pelanggan (Nota, Surat Kuasa) yang dikirim lewat WA.
// Jumlah harinya diatur Apo di Pengaturan → ⏱️ SLA & Waktu.

const HARI = 86400;

/** Masa berlaku tautan (detik) dari setelan hari. Nilai kacau → 1 hari; batas atas 10 tahun. */
export function masaDetik(hari: number): number {
  const h = Number.isFinite(hari) ? Math.floor(hari) : 0;
  return Math.min(Math.max(h, 1), 3650) * HARI;
}
